import { KeyIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const ApiModuleSwitch = ({ orgId }: { orgId: string }) => {
  const { currentData } = useGetOrganizationQuery({ orgId });
  const organization = currentData?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHandler = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        icon={KeyIcon}
        id="api-module-label"
        htmlFor="api-module"
        tooltip="Enables API access for this organization. Turning it off blocks existing API keys without revoking them."
      >
        API module
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="api-module"
          aria-labelledby="api-module-label"
          isSelected={organization.is_api_module_enabled}
          isPending={isLoading}
          onChange={(isSelected) => {
            updateOrgHandler(
              updateOrganization({
                organization_id: orgId,
                updatePayload: { is_api_module_enabled: isSelected },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
